import { readToken } from '@app/services/localStorage.service';
import { RootState, store } from '@app/store/store';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const roleApi = createApi({
  reducerPath: 'role-api',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Role'],
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: 'role/',
        params: { page, limit },
      }),
      providesTags: ['Role'],
    }),

    getRoleById: builder.query({
      query: (id) => `role/${id}`,
      providesTags: ['Role'],
    }),

    createRole: builder.mutation({
      query: (newRole) => ({
        url: 'role',
        method: 'POST',
        body: newRole,
      }),
      invalidatesTags: ['Role'],
    }),

    updateRole: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `role/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['Role'],
    }),

    deleteRole: builder.mutation({
      query: (id) => ({
        url: `role/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Role'],
    }),
  }),
});

export const {
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = roleApi;
